import "./index.css";
import App from "./App";
import React from "react";
import store from "./redux/store";
import { Provider } from "react-redux";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    {/* <BrowserRouter basename="/CT01/robot-combat-101/"> */}
    <BrowserRouter basename="/">
      <App />
    </BrowserRouter>
  </Provider>
);

reportWebVitals();
